export const loansTransactions = {
  columnParams: 'grid-cols-[1fr,1fr,1fr,3rem] sm:grid-cols-[1fr,41.666667%,1fr,1fr,3rem]',
  columns: [
    [
      { id: 'date', type: 'date', textAlign: 'text-left' },
      { id: 'description', type: 'string', textAlign: 'text-left', classNamesBody: 'truncate', classNamesBoth: 'sm:hidden' },
    ],
    [
      {
        id: 'description',
        type: 'string',
        textAlign: 'text-left',
        classNamesBoth: 'hidden sm:block',
      },
    ],
    [
      {
        id: 'quantity',
        type: 'currency',
        usesHeader: 'principal',
        textAlign: 'text-right',
      },
    ],
    [
      {
        id: 'quantityInterest',
        type: 'currency',
        usesHeader: 'interest',
        textAlign: 'text-right',
      },
    ],
    [
      {
        id: 'ellipsis',
        type: 'ellipsis',
        usesHeader: 'emptyString',
        classNamesBody: '-ml-3',
      },
    ],
  ],
};

const d = 1;
export default d;
